import request from "../utils/request";


const getAllRegistrosResoluciones = () => {
    return request({
        url: "/registros-resoluciones",
        method: "GET",
        showErrorModal: true,
    });
};

const getRegistrosResoluciones = ({
    nombreFaena=undefined, rutSolicitante=undefined, razonSocialSolicitante = undefined
}) => {
    return request({
        url: "/registros-resoluciones",
        method: "GET",
        showErrorModal: true,
        params: {
            nombreFaena, 
            rutSolicitante,
            razonSocialSolicitante
        },
    });
};



const getResolucionByNumeroResolucion = (numeroResolucion, numeradorSerieDocumental) => {
    return request({
        url: "/resolucion/" + numeroResolucion + "/numerador-serie-documental/" + numeradorSerieDocumental,
        method: "GET",
        showErrorModal: true,
    });
};





const ResolucionApi = {
    getAllRegistrosResoluciones,
    getRegistrosResoluciones,
    getResolucionByNumeroResolucion,
};
export default ResolucionApi;